'use client';
import { twMerge } from 'tailwind-merge';
import { MouseEventHandler, ReactNode } from 'react';
import Image from 'next/image';
import ctaLoadingGif from '../../../public/images/global/ctaLoader.gif';

type ButtonTypes = 'button' | 'submit';
type VariantTypes = 'primary' | 'secondary' | 'link';

interface ButtonProps {
  label: string;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  variant?: VariantTypes;
  type?: ButtonTypes;
  style?: any;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  id?: string;
  title?: string | null;
  icon?: ReactNode;
}

const VARIANTS = {
  primary: 'primary-btn',
  secondary: 'secondary-btn',
  link: 'link-btn',
};

export default function Button({
  onClick,
  className = '',
  label = 'Button',
  variant = 'primary',
  type = 'button',
  style = {},
  isLoading = false,
  disabled = false,
  id,
  title = null,
  icon,
}: ButtonProps) {
  return (
    <button
      id={id}
      type={type}
      style={style}
      onClick={onClick}
      disabled={disabled || isLoading}
      title={title || label}
      className={twMerge(
        'btn',
        VARIANTS[variant],
        className,
        isLoading ? 'opacity-70 cursor-not-allowed' : '',
        disabled
          ? 'relative flex items-center justify-center rounded-[1.8rem]'
          : ''
      )}>
      {isLoading ? (
        <div className='flex items-center justify-center h-full'>
          <Image
            src={ctaLoadingGif}
            alt='Loading...'
            fill
            unoptimized
            className='absolute inset-0 w-full object-contain'
          />
        </div>
      ) : (
        <span className='flex items-center justify-center gap-2'>
          {icon && <span className='flex items-center'>{icon}</span>}
          {label}
        </span>
      )}
    </button>
  );
}
